import { useIsNative } from './hooks/useIsNative';

export const IfNative: React.FC = ({ children }) => {

    const isNative = useIsNative();

    return isNative ? <>{children}</> : null;
};
